import { LoginMethod, UserRole, capitalizeFirst } from '@mi-front/core';
import { z } from 'zod';

export const usersAddSchema = z.object({
  email: z.string().toLowerCase().trim().min(1),
  name: z.string().trim().min(1).transform(capitalizeFirst),
  surname: z.string().trim().min(1).transform(capitalizeFirst),
  role: z.nativeEnum(UserRole),
  groupId: z
    .string()
    .transform((v) => (v === 'NONE' ? null : v))
    .nullable(),
  loginMethod: z.nativeEnum(LoginMethod),
});

export type UsersAddValues = z.infer<typeof usersAddSchema>;
